import Modal from "react-modal";

// Set the root app element for react-modal
if (document.querySelector("#root")) {
    Modal.setAppElement("#root");
}
